/*@flow*/
import downloadURL from 'lib/downloadURL';

// Example:
//
//  downloadCSV({data: ['hi,there\nyo,there'], fileName: 'foo'})
//
const downloadCSV = ({
  data,
  fileName,
  filename,
}: {
  data: string | string[],
  fileName?: string,
  filename?: string,
}) => {
  const blob = new Blob([data], { type: 'text/csv' });
  const name = fileName || filename || 'file.csv';

  if (window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveBlob(blob, name);
  } else {
    const url = window.URL.createObjectURL(blob);
    downloadURL({ fileName: name, url });

    // see: https://stackoverflow.com/a/33542499/32816
    try {
      window.URL.revokeObjectURL(blob);
    } catch (_) {} // eslint-disable-line
  }
};
window.downloadCSV = downloadCSV;
export default downloadCSV;
